import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const CareerPathChartHeaderContainer = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: space-between;

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    padding: 0 80px;
  }
`;

export const CareerPathFormContainer = styled.div`
  margin-top: 24px;
  width: 100%;
`;
